export const getPreviewGridClass = (previewColumns) => {
	if (previewColumns === 1) return "grid-cols-1";
	if (previewColumns === 2) return "grid-cols-2";
	return "grid-cols-1 lg:grid-cols-2";
};

export const getPreviewQuestionSpanClass = (colSpan, previewColumns) => {
	if (previewColumns === 1) return "col-span-1";
	if (previewColumns === 2)
		return String(colSpan) === "2" ? "col-span-2" : "col-span-1";
	return String(colSpan) === "2" ? "lg:col-span-2" : "lg:col-span-1";
};
